import React, { useEffect, useState, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Badge } from "antd";


import Footer from '../../components/Footer';
import Includes from '../../components/Includes';
import Header from '../../components/Header';
import Slider from '../../components/Slider';
import GridGallery from "../../components/GridImage";
import TourPlan from '../../components/TourPlan';
import Gallery from '../../components/Gallery';
import TitleTour from '../../components/Title';
import Location from '../../components/Location';

import ConsultForm from '../../components/Form';
import DataTravelComponent from '../../components/DataTravel';
import PriceBox from "../../components/PriceBox";



import useDataTravel from '../../hooks/useDataTravel';
import Loader from '../../components/Loader/Loader';
import { postOrder } from "../../services/orderService";

import MetaTags from "../../components/MetaTags";
import whatsapp_icon from '../../assets/icons/whatsapp_green.svg';

const Detail = () => {
    const { id: tourId } = useParams();
    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    // eslint-disable-next-line
    const { data, promoter, fetchData, isReservation, isExperience, error } = useDataTravel();
    const [loading, setLoading] = useState(true);
    const [isOrderLoading, setIsOrderLoading] = useState(false);
    const [numPassengers, setNumPassengers] = useState(1);
    const [isSticky, setIsSticky] = useState(false);
    const [selectedDate, setSelectedDate] = useState(""); // accepts string date ISO 8601
    const [selectedOption, setSelectedOption] = useState(""); // accepts string date ISO 8601
    const [showRibbon, setShowRibbon] = useState(false)
    const [riBBonText, setRiBBonText] = useState('')
    const [isValid, setIsValid] = useState(true)
    const [isOptionValid, setIsOptionValid] = useState(true)



    const consultFormRef = useRef<HTMLDivElement>(null);
    const footerRef = useRef<HTMLDivElement>(null);
    const detailRef = useRef<HTMLDivElement>(null);
    const formContainer = useRef<HTMLDivElement>(null);
    // eslint-disable-next-line
    const verticalFormRef = useRef<HTMLDivElement>(null);
    const asideRef = useRef<HTMLDivElement>(null);

    // const flag = searchParams.get('flag');
    const flag = "checkout-api"
    const token = searchParams.get('token');

    const hasGalleryImages = Array.isArray(data?.gallery) && data.gallery.length > 0;
    const hasMap = data?.maps !== null;
    const hasIncludes = !!(data?.included?.length || data?.notIncluded?.length)
    const hasTourPlan = Array.isArray(data?.plan) && data.plan.length > 0;
    const LOWER_STOCK = 10;

    const [imageUrl, setImageUrl] = useState('');
    const [currentUrl, setCurrentUrl] = useState('');
    const [isMetaDataReady, setIsMetaDataReady] = useState(false);

    useEffect(() => {
        if (data && data.slider) {
            const availableImages = data.slider;
            const imgIdx = 0;

            try {
                const newImageUrl = availableImages[imgIdx]?.startsWith('http') || availableImages[imgIdx]?.startsWith('https')
                    ? availableImages[imgIdx]
                    : new URL(availableImages[imgIdx], window.location.origin).href;

                setImageUrl(newImageUrl || '');
                setCurrentUrl(window.location.origin + window.location.pathname + window.location.search);
                setIsMetaDataReady(true);
            } catch (e) {
                setImageUrl('');
                setIsMetaDataReady(false);
            }
        }
    }, [data]);



    const handleScroll = () => {
        const pageTop = window.scrollY;
        const footerRect = isMobile && footerRef ? footerRef?.current?.getBoundingClientRect() : false;
        const windowHeight = window.innerHeight;
        if (isMobile && footerRect) {
            if (asideRef.current && formContainer.current) {
                asideRef.current.style.height = `${formContainer.current.getBoundingClientRect().height}px`;
            }
            if (formContainer.current && asideRef.current) {
                formContainer.current.style.width = `${asideRef.current.getBoundingClientRect().width}px`;
            }
            if (pageTop > 100) {
                if (footerRect.top < windowHeight) {
                    setIsSticky(false)
                } else {
                    setIsSticky(true)
                }
            } else {
                setIsSticky(false)
            }
        }
    };


    const handleBuyClick = async () => {
        setIsOrderLoading(true);
        try {
            if (selectedOption) {
                await postOrder(data?.id || '', selectedDate, selectedOption);
            } else {
                await postOrder(data?.id, selectedDate);
            }

            let passengersQuery = '';
            if (numPassengers > 1) passengersQuery = "?num_passengers=" + numPassengers
            navigate("/checkout/passengers" + passengersQuery)
        } catch (e) {
            setIsOrderLoading(false)
        }
    };

    const handlePhoneClick = () => {
        const message = encodeURI(
            "Hola! Queria consultar por el viaje *" + data?.title + "*"
        );
        window?.open("https://wa.me/5491127516586?text=" + message, "_blank")?.focus();
    };

    const handleSpecialPriceClick = () => {
        window?.open(`${promoter?.viewMoreURL}`, "_blank")?.focus();
    };

    const handleOnDateChange = (date: string) => {
        setSelectedDate(date)
    }

    const handleOnOptionsChange = (option: string) => {
        setSelectedOption(option)
    }


    const scrollToElement = (id: string) => {
        const element = document.getElementById(id);

        if (element) {
            const rect = element.getBoundingClientRect();
            const isVisible =
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth);

            if (!isVisible) {
                element.scrollIntoView({
                    behavior: 'smooth', // Optional: 'auto' for instant scroll
                    block: 'center',    // Scroll the element into the center of the view
                });
            }
        }
    };

    const _handleSubmit = () => {
        if (isExperience) {
            if (!selectedDate) {
                setIsValid(false)
                scrollToElement('priceBox')
            } else {
                setIsValid(true)
            }

            if (!selectedOption) {
                if (!selectedOption) {
                    setIsOptionValid(false)
                    scrollToElement('priceBox')
                } else {
                    setIsOptionValid(true)
                }
            }

            if (data?.options && data?.options?.length > 0) {
                if (isValid && isOptionValid) {
                    handleBuyClick()
                }
            } else {
                if (isValid) {
                    handleBuyClick()
                }
            }
        } else {
            if (data?.options && data?.options?.length > 0) {
                if (!selectedOption) {
                    if (!selectedOption) {
                        setIsOptionValid(false)
                        scrollToElement('priceBox')
                    } else {
                        setIsOptionValid(true)
                    }
                }
                if (isOptionValid) {
                    handleBuyClick()
                }
            } else {
                handleBuyClick()
            }
        }
    }

    const showPriceBox = () => {

        if (!data) return;

        const PriceBoxComponent = () => <PriceBox
            setNumPassengers={setNumPassengers}
            numPassengers={numPassengers}
            quotation={data}
            isExperience={isExperience}
            handleSubmit={_handleSubmit}
            handlePhoneClick={handlePhoneClick}
            handleSpecialPriceClick={handleSpecialPriceClick}
            isOrderLoading={isOrderLoading}
            isReservation={isReservation}
            onDateChange={handleOnDateChange}
            label={data?.stock === 0 ? 'SOLD OUT' : "Reservar ahora"}
            selectedDate={selectedDate}
            setIsValid={setIsValid}
            isValid={isValid}
            isOptionValid={isOptionValid}
            setIsOptionValid={setIsOptionValid}
            specialPrice={data?.should_show_special_price ? data?.should_show_special_price : false}
            haveOptions={data?.options && data?.options.length > 0}
            options={data?.options ? data?.options : []}
            onOptionChange={handleOnOptionsChange}
        />


        if (showRibbon) {
            return (
                <Badge.Ribbon
                    text={riBBonText}
                    color="red"
                    placement="start"
                >
                    <PriceBoxComponent />
                </Badge.Ribbon>
            )
        }

        return (
            <PriceBoxComponent />
        )
    }



    useEffect(() => {
        setIsSmallScreen(isMobile);


        if (tourId) {
            fetchData(token ? `${tourId}?token=${token}` : tourId).then((result) => {
                setLoading(true);

                if (result.data.promoter !== result.promoter.alias) {
                    const host = window.location.host.split('.').slice(1).join('.');
                    window.location.href = `${window.location.protocol}//${result.data.promoter}.${host}/trip/${tourId}`;
                }
                setLoading(false);
            });

        } else {
            //console.error("No ID provided in URL");
            navigate('/home');
        }

        const handleResize = () => {
            setIsSmallScreen(isMobile);
        };
        window.addEventListener('resize', handleResize, { passive: true });
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleScroll);
        };
    }, [tourId, token, fetchData, navigate]);

    useEffect(() => {
        if (data?.stock === 0) {
            setRiBBonText("SOLD OUT");
            if (!isMobile) {
                setShowRibbon(true)
            }

        } else if (data?.stock !== undefined && data.stock <= LOWER_STOCK && data.stock > 1) {
            setRiBBonText(`Últimos ${data?.stock} lugares`);
            if (!isMobile) {
                setShowRibbon(true)
            }
        } else if (data?.stock === 1) {
            setRiBBonText('Último lugar');
            if (!isMobile) {
                setShowRibbon(true)
            }
        } else {
            setShowRibbon(false)
        }
    }, [data]);


    // Update the loading check
    if (loading || data === null || promoter === null || !isMetaDataReady) {
        return <Loader />;
    }


    return (
        <HelmetProvider>
            <MetaTags
                name={promoter.fullname}
                image={imageUrl}
                description={data?.description}
                icon={promoter.logoURL}
                title={data.title}
                url={currentUrl}
                font={data.font || null}
                primaryColor={data.colors?.primary_color || null}
                secondaryColor={data.colors?.secondary_color || null}
            />
            <div className='detail' ref={detailRef}>
                <Header
                    promoter={promoter}
                    loading={loading}
                    error={error}
                    onBuyClick={_handleSubmit}
                    handlePhoneClick={handlePhoneClick}
                    showGalleryLink={hasGalleryImages}
                    showIncludes={hasIncludes}
                    showTourPlan={hasTourPlan}
                    isOrderLoading={isOrderLoading}
                    flag={flag}
                    labelButton={data?.stock === 0 ? 'SOLD OUT' : "Reservar ahora"}
                    stock={data?.stock}
                />

                <div className='content-wrapper'>
                    <TitleTour title={data.title} promoter={promoter} />
                    {isExperience ? (
                        <GridGallery data={{ slider: data['slider'] }} loading={loading} error={error} />
                    ) : (
                        <Slider data={{ slider: data['slider'] }} loading={loading} error={error} />
                    )}
                </div>

                <div className='main-content'>
                    <div className='text-section' id="datatravel">
                        <h2 id="datatravel-title" dangerouslySetInnerHTML={{ __html: data?.description }}></h2>
                        <div>
                            <DataTravelComponent data={data} loading={loading} error={error} isExperience={isExperience} />
                        </div>
                        <p className='datatravel__p' dangerouslySetInnerHTML={{ __html: data?.description2 }}></p>
                        {hasIncludes && (
                            <div className='includes' id="includes">
                                <Includes data={{
                                    included: data['included'],
                                    notIncluded: data['notIncluded']
                                }} loading={loading} error={error} />
                            </div>
                        )}
                        {hasTourPlan && (
                            <div className='tourplan' id="tourplan">
                                <TourPlan data={{ plan: data['plan'] }} isExperience={isExperience} />
                            </div>
                        )}
                        {isSmallScreen && (
                            <div className="phone_detail" onClick={handlePhoneClick}>
                                <span>¿Tienes dudas?</span>
                                <img className="wp_img" src={whatsapp_icon} alt="icono de whatsapp" />
                            </div>
                        )}
                        {hasMap && (
                            <div className='map' id="map">
                                <Location data={data} loading={loading} error={error} />
                            </div>
                        )}
                        {hasGalleryImages && (
                            <div className='gallery' id="gallery">
                                <Gallery data={{ gallery: data['gallery'] }} />
                            </div>
                        )}
                    </div>

                    <div className='aside' ref={asideRef}>
                        <div className={`form-container ${isSticky ? 'sticky' : ''}`} ref={formContainer} id="priceBox">
                            {flag === "checkout-api" ? (
                                showPriceBox()
                            ) : (
                                // @ts-ignore no esta en .ts todavia
                                <ConsultForm ref={consultFormRef} tourId={tourId} />
                            )}
                        </div>
                    </div>
                </div>
                <Footer ref={footerRef} promoter={promoter} loading={loading} />
            </div>
        </HelmetProvider>
    );
};

export default Detail;
